import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import { calendlyProviderUiModule } from './calendly';
import { edularProviderUiModule } from './edular';
import { hubspotProviderUiModule } from './hubspot';
import { googleCalendarProviderUiModule } from './google-calendar';
import { microsoft365CalendarProviderUiModule } from './microsoft-365-calendar';
import { campusLoginProviderUiModule } from './campus-login';
import { zapierProviderUiModule } from './zapier';
import { pacificOneHealthProviderUiModule } from './pacific-one-health';
import type { McpProviderUiConfig, McpProviderUiModule } from './types';

const defaultModule: McpProviderUiModule = {
  providerCode: 'generic',
  matches: () => true,
  getUiConfig: () => ({
    providerCode: 'generic',
    displayName: 'MCP',
    supportsDynamicClientRegistration: false,
    requireClientId: true,
    requireClientSecret: true,
    endpointOverrideLabel: 'Endpoint Override',
    endpointOverridePlaceholder: 'Optional custom endpoint',
    endpointOverrideHelpText: 'Leave empty to use the platform master endpoint.',
    oauthClientIdLabel: 'OAuth Client ID',
    oauthClientSecretLabel: 'OAuth Client Secret',
  }),
};

const modules: McpProviderUiModule[] = [
  calendlyProviderUiModule,
  hubspotProviderUiModule,
  edularProviderUiModule,
  googleCalendarProviderUiModule,
  microsoft365CalendarProviderUiModule,
  campusLoginProviderUiModule,
  zapierProviderUiModule,
  pacificOneHealthProviderUiModule,
  defaultModule,
];

export const resolveMcpProviderUiConfig = (integration: ManagedMcpIntegration): McpProviderUiConfig => {
  const module = modules.find((candidate) => candidate.matches(integration)) || defaultModule;
  return module.getUiConfig(integration);
};
